import { CALL_API } from "redux-api-middleware";
import comparable from "apis/comparable";
import {
  REQUEST_PROPMIXSSO, RECEIVE_PROPMIXSSO, ERROR_PROPMIXSSO,
  REQUEST_COMPARABLEDETAILS, RECEIVE_COMPARABLEDETAILS, ERROR_COMPARABLEDETAILS,
  REQUEST_GRIDDATA, RECEIVE_GRIDDATA, ERROR_GRIDDATA,
  REQUEST_GRIDDATA_POST, RECEIVE_GRIDDATA_POST, ERROR_GRIDDATA_POST,
} from "typeConstants";
import responseHandler from "responseHandler";

const getComparableDetails = (token) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: comparable.getResult("propmix", token),
        method: "GET",
        types: [
          REQUEST_COMPARABLEDETAILS,
          {
            type: RECEIVE_COMPARABLEDETAILS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_COMPARABLEDETAILS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getPropmixSso = (id) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: comparable.getSsoUrl(id, "propmix"),
        method: "GET",
        types: [
          REQUEST_PROPMIXSSO,
          {
            type: RECEIVE_PROPMIXSSO,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_PROPMIXSSO,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const getGridData = (controlNumber) => {
  return function (dispatch) {

    dispatch({
      [CALL_API]: {
        endpoint: comparable.gridData(controlNumber),
        method: "GET",
        types: [
          REQUEST_GRIDDATA,
          {
            type: RECEIVE_GRIDDATA,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  data.loadedOnDate = new Date();
                  return data;
                })
          }, {
            type: ERROR_GRIDDATA,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    );
  };
};

const storeGridData = (controlNumber, compGrid, callback) => {
  return function (dispatch) {
    dispatch({
      [CALL_API]: {
        endpoint: comparable.gridData(controlNumber),
        method: "POST",
        body: JSON.stringify(compGrid),
        types: [
          REQUEST_GRIDDATA_POST,
          {
            type: RECEIVE_GRIDDATA_POST,
            payload: (action, state, res) => 
              res.json()
                .then(data => {
                  data.loadedOnDate = new Date();
                  return data;
                })
            
          }, {
            type: ERROR_GRIDDATA_POST,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }
    ).then(callback);
  };
};

export {
  getComparableDetails,
  getPropmixSso,
  getGridData,
  storeGridData,
};
